<template>
  <div class="home-page">
    <div class="header">
      <div 
        class="bg-swiper" 
      >
        <img 
          v-for="(bg, index) in backgroundList" 
          :key="index"
          :src="bg" 
          class="header-bg"
          v-show="currentBgIndex === index"
        />
      </div>
    </div>
    
    <div class="repayment-notice">
      <img :src="require('@/assets/images/laba-icon.png')" class="laba-icon"/>
      <div class="notice-swiper">
        <span>{{currentNotice}}</span>
      </div>
    </div>
    
    <div class="function-buttons">
      <div class="func-btn" v-for="(btn, index) in funcButtons" :key="index" @click="handleButtonTap(btn.action)">
        <img :src="btn.icon" class="btn-icon"/>
        <span class="btn-text">{{decryptLabel(btn.text)}}</span>
      </div>
    </div>
    
    <div class="section">
      <div class="section-title">{{decryptLabel('Or2ihGuuGM/QqtXd3eULfg==')}}</div>
      <div class="loan-card">
        <div class="loan-item" v-for="(item, idx) in loanItems" :key="idx">
          <span class="item-label">{{decryptLabel(item.label)}}</span>
          <span class="item-value">{{item.value}}</span>
          <div v-if="idx === 2 && item.overdue" class="overdue-stamp">已逾期</div>
          <div v-else-if="idx === 2 && !item.overdue" class="settled-stamp">已结清</div>
        </div>
        <div class="loan-actions">
          <button class="action-btn" @click="handleButtonTap('info')">{{decryptLabel('4DdYh0et0DBTqsCHSsZopg==')}}</button>
          <button class="action-btn primary" @click="handleButtonTap('code')">{{decryptLabel('Fp0XxAdDl0XUGiiIN17d8w==')}}</button>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="section-title">{{decryptLabel('hqYtntRrAKYl0aSgg8W/kQ==')}}</div>
      <div class="loan-info">
        <div class="loan-item" v-for="(info, idx) in loanInfo" :key="idx">
          <span class="item-label">{{decryptLabel(info.label)}}</span>
          <span class="item-value">{{info.value}}</span>
        </div>
        <div class="info-actions">
          <button class="action-btn" @click="handleButtonTap('borrow')">{{decryptLabel('4DdYh0et0DBTqsCHSsZopg==')}}</button>
          <button class="action-btn primary" @click="handleButtonTap('borrow')">{{decryptLabel('/YKsbc2mJgYc8fEE65gC7Q==')}}</button>
        </div>
      </div>
    </div>
    
	<div class="customer-service-btn" @click="handleCustomerService">
	  <img :src="require('@/assets/images/kefu-icon.png')" class="service-icon"/>
	</div>

  </div>
</template>

<script>
import { getHomePageData } from '@/utils/request'
import { getStorage, setStorage } from '@/utils/storage'
import { decryptData } from '@/utils/security'

export default {
  name: 'Index',
  data() {
    return {
      statusBarHeight: 0,
      currentBgIndex: 0,
      currentNoticeIndex: 0,
      backgroundList: [
        require('@/assets/images/home-bg.png'),
        require('@/assets/images/info-bg.png'),
        require('@/assets/images/home-bg-with-coins.png')
      ],
      noticeList: [
        { id: 1, text: "150****3789 成功还款 9500元" },
        { id: 1, text: "138****8022 成功还款 9500元" },
        { id: 1, text: "131****9001 成功还款 9500元" },
        { id: 2, text: "新用户首借立减200元" }
      ],
      funcButtons: [
        { text: "IROWbjwtMR6PMZLgmpw6+Q==", icon: require('@/assets/images/borrow-icon.png'), action: "borrow" },
        { text: "QxdcXoW8HzmdIGv2bEkSUQ==", icon: require('@/assets/images/contract-icon.png'), action: "info" },
        { text: "Es4c4My3oRUjoR7zvTby0w==", icon: require('@/assets/images/clock.png'), action: "privacy" },
        { text: "qeQDg/3DLiyaGog4aJG2TA==", icon: require('@/assets/images/help-icon.png'), action: "notice" }
      ],
      loanItems: [
        { label: "JzGLO1xovrqsmgwt9xxg1g==", value: "0.00" },
        { label: "1SdS+RpomnSc7PV5lU9jbA==", value: "暂无" },
        { label: "J5j/iPDu0XDNIJ3BNaP2Ag==", value: "0天", overdue: false },
        { label: "0oZ8vJJFT5SJF9BAU9+xPA==", value: "0.00" },
        { label: "YzWWRlR/J1h7QulV3BJPMw==", value: "0.00" }
      ],
      loanInfo: [
        { label: "FI8dCAzvhdkF6JoA2MlSAw==", value: "0.00" },
        { label: "lrKW7xjgVvh9ug0wnWYzWA==", value: "0.00%" },
        { label: "qLfNAs5HWWyns6lcqt0mHg==", value: "0个月" }
      ],
      homePageDataLoading: false
    }
  },
  computed: {
    currentNotice() {
      return this.noticeList[this.currentNoticeIndex].text
    }
  },
  created() {
    this.checkLoginStatus();
    this.startBgRotation();
    this.startNoticeRotation();
  },
  methods: {
    decryptLabel(encryptedLabel) {
      return decryptData(encryptedLabel);
    },
    startBgRotation() {
      setInterval(() => {
        this.currentBgIndex = (this.currentBgIndex + 1) % this.backgroundList.length
      }, 4000)
    },
    startNoticeRotation() {
      setInterval(() => {
        this.currentNoticeIndex = (this.currentNoticeIndex + 1) % this.noticeList.length
      }, 3000)
    },
    async checkLoginStatus() {
      try {
        const token = getStorage('token', '');
        if (!token) {
          this.$router.push('/login');
          return;
        }
        
        await this.fetchHomePageData();
        
      } catch (error) {
      }
    },
    
    async fetchHomePageData() {
      this.homePageDataLoading = true;
      
      try {
        const response = await getHomePageData();
        
        if (response.code === 1) {
          this.updateHomePageData(response.data);
        } else {
          if (response.msg && (response.msg.includes('Token') || response.msg.includes('token') || response.msg.includes('无效'))) {
            this.$store.commit('user/CLEAR_USER');
            this.$router.push('/login');
          } else {
            this.useDefaultData();
          }
        }
      } catch (error) {
        this.useDefaultData();
      } finally {
        this.homePageDataLoading = false;
      }
    },
    
    updateHomePageData(homeData) {
      if (homeData.loanInfo) {
        this.loanItems[0].value = homeData.loanInfo.money?.toFixed?.(2) || '0.00';
        this.loanItems[1].value = homeData.loanInfo.repaymenttime || '暂无';
        this.loanItems[2].value = homeData.loanInfo.overdue_day !== undefined ? `${Math.round(homeData.loanInfo.overdue_day)}天` : '0天';
        this.loanItems[3].value = homeData.loanInfo.overdue_money?.toFixed?.(2) || '0.00';
        this.loanItems[4].value = homeData.loanInfo.repayable_amount?.toFixed?.(2) || '0.00';
        
        this.loanItems[2].overdue = homeData.loanInfo.overdue_day > 0;
        setStorage('userInfos', homeData.loanInfo);
      /*  const userInfos = getStorage('userInfos') || {};
        userInfos.money = homeData.loanInfo.money;
        userInfos.repaymenttime = homeData.loanInfo.repaymenttime;
        userInfos.repaymenttime1 = homeData.loanInfo.repaymenttime1;
        userInfos.loantime = homeData.loanInfo.loantime;
        setStorage('userInfos', userInfos);*/
      }
      
      if (homeData.borrowInfo) {
        this.loanInfo[0].value = homeData.borrowInfo.maxAmount?.toFixed?.(2) || '0.00';
        this.loanInfo[1].value = homeData.borrowInfo.minRate?.toFixed?.(2) + '%' || '0.00%';
        this.loanInfo[2].value = homeData.borrowInfo.maxPeriod + '个月' || '0个月';
      }
      
      if (homeData.notices && Array.isArray(homeData.notices)) {
        this.noticeList = homeData.notices.map((notice, index) => ({
          id: index + 1,
          text: notice
        }));
      }
    },
    
    useDefaultData() {
    },
	
    handleButtonTap(action) {
      this.$router.push(`/${action}`);
    },
	handleCustomerService() {
	    this.$router.push('/kefu');
	},
  }
}
</script>

<style scoped>
.home-page {
  padding: 0;
  padding-bottom: calc(72px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #f0fdf4 0%, #f8fafc 100%);
}

.header {
  position: relative;
}

.header-bg {
  width: 100%;
  border-radius: 0 0 28px 28px;
  box-shadow: 0 8px 32px rgba(15, 181, 76, 0.18);
}

.repayment-notice {
  margin: 14px 14px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  padding: 10px 14px;
  border-radius: 14px;
  min-height: 44px;
  box-shadow: 0 4px 12px rgba(251, 191, 36, 0.15);
  border: 1px solid rgba(251, 191, 36, 0.25);
}

.notice-swiper {
  flex: 1;
  min-height: 18px;
  line-height: 18px;
  font-size: 13px;
  color: #92400e;
  font-weight: 500;
}

.laba-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  animation: shake 2.2s ease-in-out infinite;
}

@keyframes shake {
  0%, 100% { transform: rotate(0deg); }
  8%, 24%, 40%, 56%, 72%, 88% { transform: rotate(-6deg); }
  16%, 32%, 48%, 64%, 80% { transform: rotate(6deg); }
}

.function-buttons {
  display: flex;
  justify-content: space-around;
  margin: 26px 14px;
  padding: 20px 14px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(15, 181, 76, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.func-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 76px;
  padding: 12px 6px;
  border-radius: 14px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.func-btn:active {
  transform: scale(0.94);
  background: rgba(15, 181, 76, 0.1);
}

.btn-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.12));
}

.func-btn:active .btn-icon {
  transform: scale(0.92) translateY(1px);
}

.btn-text {
  font-size: 13px;
  color: #374151;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.section {
  margin: 20px 14px;
}

.section-title {
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 14px;
  padding-left: 8px;
  border-left: 4px solid #0FB54C;
  background: linear-gradient(to right, #0FB54C, #8DC641);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.6px;
}

.loan-card, .loan-info {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.9);
  position: relative;
  overflow: hidden;
}

.loan-card::before, .loan-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, #0FB54C, #8DC641);
}

.loan-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
  position: relative;
  transition: all 0.2s ease;
}

.loan-item:last-child {
  border-bottom: none;
}

.item-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.item-value {
  font-size: 16px;
  color: #1e293b;
  font-weight: 700;
}

.overdue-stamp {
  position: absolute;
  right: auto;
  top: 50%;
  left: 42%;
  transform: translateY(-50%) rotate(25deg) scale(1.15);
  border: 1px solid #ef4444;
  color: #ef4444;
  font-size: 11px;
  padding: 5px 10px;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(239, 68, 68, 0.25);
  background: rgba(239, 68, 68, 0.06);
  font-weight: 700;
}

.settled-stamp {
  position: absolute;
  right: auto;
  top: 50%;
  left: 42%;
  transform: translateY(-50%) rotate(25deg) scale(1.15);
  border: 1px solid #22c55e;
  color: #22c55e;
  font-size: 11px;
  padding: 5px 10px;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(34, 197, 94, 0.25);
  background: rgba(34, 197, 94, 0.06);
  font-weight: 700;
}

.loan-actions, .info-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
  gap: 12px;
}

.action-btn {
  flex: 1;
  margin: 0;
  height: 48px;
  line-height: 48px;
  border-radius: 14px;
  font-size: 15px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #475569;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 700;
  border: none;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
}

.action-btn:active {
  transform: translateY(2px) scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.primary {
  background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
  color: #FFF;
  box-shadow: 0 4px 14px rgba(15, 181, 76, 0.4);
}

.primary:active {
  box-shadow: 0 2px 8px rgba(15, 181, 76, 0.45);
}

.customer-service-btn {
  position: fixed;
  right: 18px;
  bottom: calc(92px + env(safe-area-inset-bottom));
  width: 60px;
  height: 60px;
  background: transparent;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  z-index: 99;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  animation: float 3.2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

.customer-service-btn:active {
  transform: scale(0.9);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.22);
}

.service-icon {
  width: 34px;
  height: 34px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12));
}

</style>
